import CustomScroll from "@src/component/customScroll";
import { getQueryParams } from "@src/util";
import { memo, useEffect, useState } from "react";
import { getContractDetail } from "@service/ownService";
import { Toast } from 'antd-mobile'
import "./index.scss"

const LoanDetail = () => {
  const search = getQueryParams();
  const [contractInfo, setContractInfo] = useState<any[]>([]);
  const [rejectReason, setRejectReason] = useState("");
  useEffect(() => {
    document.title = "我的融租合同"
  }, [])

  useEffect(() => {
    getContractDetail(`/api/loaning/getContractDetail?loaningInfoId=${search.loanid ? (search.loanid as string) : ""}`, {}).then((res) => {
      if (res.errcode === 0) {
        setContractInfo(res.data.data.contractInfo ? res.data.data.contractInfo : []);
        setRejectReason(res.data.data.rejectReason);
      }
    }).catch(err => {
      Toast.show(err?.errmsg || '获取融租合同详情失败')
    })
  }, [])

  // 复制
  const copy = (str: string) => {
    const createInput = document.createElement("input");
    createInput.value = str;
    document.body.appendChild(createInput);
    createInput.select();
    document.execCommand("Copy"); // document执行复制操作
    createInput.remove();
    Toast.show("复制链接成功，请到外部浏览打开");
  }

  return (
    <div className="page bottomFit LoanDetail">
      <CustomScroll>
        {rejectReason && <div className="header">
          <span className="title">驳回理由：</span>
          {rejectReason}
        </div>}
        <ul>
          {contractInfo.map((_ele, index) => (
            <li key={index}>
              <div className="section"><div>{_ele.name}</div></div>
              <div className="title" onClick={() => { copy(_ele.url) }}>复制链接</div>
            </li>
          ))}

        </ul>
      </CustomScroll>
    </div>)
}


export default memo(LoanDetail);